<div role="dialog" aria-modal="true" aria-labelledby="modal-title-onboard-blueprint">
  <div class="modal-header">
    <h2 id="modal-title-onboard-blueprint" class="modal-title h4">Onboard a new service blueprint</h2>
  </div>
  <form #ngForm="ngForm" (ngSubmit)="ngForm.valid && submit()">
    <div class="modal-body">
      <label style="width: 100%" *ngIf="customTeam === false; else CustomTeamOID">
        <span>Select the service that you own</span>
        <ng-select
          name="TeamName"
          [(ngModel)]="team"
          [items]="teamList"
          groupBy="ring"
          placeholder="Start typing"
          [virtualScroll]="true"
          required
          data-test="TeamName"
          #teamName="ngModel">
          <ng-template ng-option-tmp let-item="item">
            <ng-container>
              <label title="{{ item.label }}" attr.data-test="{{ item.label }}">
                {{ item.label }}
              </label>
            </ng-container>
          </ng-template>
        </ng-select>
      </label>
      <ng-template #CustomTeamOID>
        <input [(ngModel)]="teamOid" class="form-control" type="text" name="TeamOID" />
      </ng-template>
      <label class="mb-3" style="width: 100%">
        <input type="checkbox" [(ngModel)]="customTeam" name="CustomTeam" />
        <span class="ms-1" for="CustomTeam">My service is not in the list. Let me enter the service tree ID directly.</span>
      </label>

      <div *ngIf="isPlannedQuotaV2Supported()">
        <label style="width: 100%">
          <span>Select the blueprint kind (<a href="https://aka.ms/catseye-multiple-blueprints" target="_blank" rel="noopener noreferrer">Learn more</a>)</span>
          <ng-select
            name="planKind"
            [ngModel]="isNewOnboarding() ? 'NewRegion' : planKind"
            (ngModelChange)="planKind = $event"
            [items]="planKindList"
            [virtualScroll]="true"
            bindValue="key"
            bindLabel="value"
            required
            data-test="planKind"
            #planTypeName="ngModel"
            [disabled]="isNewOnboarding()">
            <ng-template ng-option-tmp let-item="item">
              <ng-container>
                <label title="{{ item.value }}" attr.data-test="{{ item.value }}">
                  {{ item.value }}
                </label>
              </ng-container>
            </ng-template>
          </ng-select>
        </label>
        <div class="mb-3" *ngIf="!isNewOnboarding()">
          <label>
            <input
              type="checkbox"
              name="needsQuotaInEveryRegion"
              [(ngModel)]="needsQuotaInEveryRegion"
              (ngModelChange)="onEveryRegionChange()"
              data-test="needsQuotaInEveryRegion" />
            <span class="ms-1">Check to enable <b>New Region</b>. My service needs the quota declared in this blueprint in <b>EVERY</b> region.</span>
          </label>
          <div class="form-text" [ngSwitch]="planKind">
            <span *ngSwitchCase="PlanKindEnum.NewRegion">
              New Region blueprints must be region agnostic. They will be auto assigned to regions if your service is in scope of region
              <a href="https://aka.ms/pslwiki" target="_blank" rel="noopener noreferrer">PSL</a>.
            </span>
            <span *ngSwitchCase="PlanKindEnum.ZoneExpansion">
              Zone Expansion blueprints will be auto assigned to regions if your service is in scope of zone expansion
              <a href="https://aka.ms/pslwiki" target="_blank" rel="noopener noreferrer">PSL</a>.
            </span>
            <span *ngSwitchCase="PlanKindEnum.Growth">
              Growth blueprints can only be assigned to live regions and can be assigned multiple times.
            </span>
          </div>
        </div>
        <label class="mb-3" style="width: 100%">
          <span>Blueprint Name (<b>Region Agnostic</b>)</span>
          <input
            class="form-control"
            [ngModel]="isNewOnboarding() ? 'GA' : planName"
            (ngModelChange)="planName = $event"
            name="planName"
            title="planName"
            placeholder="*DO NOT* use cloud/region specific names"
            required
            #name="ngModel"
            [disabled]="isNewOnboarding()" />
          <ng-container *ngIf="isTouchedOrDirty(name)">
            <em *ngIf="name.errors?.required">Required<br /></em>
            <em *ngIf="!isNameValid">The service blueprint name allows only alphabets and numbers without any space. Max length is {{maxPlanNameLength}}</em>
          </ng-container>
        </label>
      </div>
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-primary" [disabled]="ngForm.invalid || disableSubmit()" data-test="Submit">OK</button>
      <button type="button" class="btn btn-secondary" (click)="activeModal.close()">Cancel</button>
    </div>
  </form>
</div>
